// extracted by mini-css-extract-plugin
export default {"wizard-body-main":"fA59N4Gu0z_lqUQ92bct","wizard-body-main--with-preview":"kWh38ohUfJJaxqJToujz"};